// extracted by mini-css-extract-plugin
export var modalFooter = "_q1-0";